import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: {},
  loading: false,
  isUserLogout: false,
  errorMsg: "",
  error: false,
  organizations: [], // Ensure this is initialized as an empty array
  showOrgModal: false, // Ensure this is initialized
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      state.loading = false;
      state.error = true;
      state.isUserLogout = false;
      state.errorMsg = action.payload || "Username & password is wrong";
    },
    enableLoading(state) {
      state.loading = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload;
      state.loading = false;
      state.error = false;
      state.errorMsg = ""; // Clear error message on success
      state.isUserLogout = false;
    },
    logoutUserSuccess(state) {
      state.isUserLogout = true;
    },
  },
});

export const { apiError, loginSuccess, logoutUserSuccess, enableLoading } =
  loginSlice.actions;

export default loginSlice.reducer;
